import type { DefaultOptions } from "@tanstack/react-query";

declare module "@tanstack/react-query" {
  interface Register {
    mutationMeta: {
      skipInvalidation?: boolean;
      // Refetch right after success instead of waiting out the global debounce.
      invalidateImmediately?: boolean;
    };
  }
}

export const STALE_TIME = 60 * 1000;

export const queryClientDefaultOptions: DefaultOptions = {
  queries: {
    staleTime: STALE_TIME,
    gcTime: STALE_TIME * 5, // 5 minutes garbage collection time
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      if (failureCount >= 3) return false;
      const status = (error as { response?: { status?: number } })?.response?.status;
      // No status means a network-level failure (DNS, connection reset, etc.) — always retry
      if (!status) return true;
      // Retry on server errors and transient HTTP statuses
      return status >= 500 || status === 408 || status === 429;
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30_000),
  },
};
